import { useNavigate } from 'react-router-dom';

import PageContainer from '@/components/Container/PageContainer';
import CitizenCaseApplication from '@/components/Pbl/CitizenCaseApplication';
import { TitleBar, TitleText } from '@/components/Pbl/CitizenCaseApplication/styles';
import { Button } from '@/components/UI/Button';
import { getAuthSelector } from '@/redux/auth/auth.slice';
import { useAppSelector } from '@/redux/store.hook';
import useResize from '@/hooks/useResize';
import { useTranslation } from 'react-i18next';

const PblCitizenCaseApplication = () => {
  //   @ts-ignore
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useResize();
  const { userData } = useAppSelector(getAuthSelector);

  return (
    <PageContainer
      title={
        <TitleBar isMobile={isMobile}>
          <Button type="button" size="md" variant="primary" rounded={false} onClick={() => navigate('/home')}>
            {t('pbl.pagesHardcoded.citizenCaseApplication.back')}</Button>
          <TitleText>
            <strong>{t('pbl.pagesHardcoded.citizenCaseApplication.proBonoLegalServiceCases')}</strong>
          </TitleText>
        </TitleBar>
      }
    >
      <CitizenCaseApplication userData={userData} />
    </PageContainer>
  );
};

export default PblCitizenCaseApplication;
